import { Form } from "top-component-library";
import EmailInput from "top-component-library/form-inputs/EmailInput";
import PhoneInput from "top-component-library/form-inputs/PhoneInput";
import RadioInput from "top-component-library/form-inputs/RadioInput";
import SelectInput from "top-component-library/form-inputs/SelectInput";
import TextInput from "top-component-library/form-inputs/TextInput";

import { StepContainer } from "./styles";

// Step 1: pick an existing employee or enter a new contact. The employee/new sub-forms are
// gated on the live form value via Form.Item shouldUpdate (no manual re-render needed).
const RecipientStep = ({ contactForm, employeeArray, recipientToAdd, setRecipientToAdd, onSelectEmployee }) => (
  <StepContainer>
    <div>
      <p>
        Step 1: Choose somebody to receive the alerts. This can be an existing employee in our system, or a new contact.
      </p>
    </div>
    <Form form={contactForm} layout="vertical">
      <RadioInput
        id="employee-or-contact"
        name="employeeOrContact"
        choices={[
          { label: "Choose an employee", value: "employee" },
          { label: "Add a new contact", value: "new" },
        ]}
        button
        onChange={(e) => setRecipientToAdd({ ...recipientToAdd, employeeOrContact: e.target.value })}
      />
      <Form.Item noStyle shouldUpdate>
        {() => {
          const mode = contactForm.getFieldValue("employeeOrContact");
          return (
            <>
              {mode === "employee" && (
                <>
                  <SelectInput
                    id="add-employee"
                    options={employeeArray}
                    typeAhead
                    label="Select an employee"
                    name="employee"
                    onChange={onSelectEmployee}
                    placeholder="Employee"
                  />
                  <EmailInput
                    disabled
                    label="Email"
                    name="staffEmail"
                    id="staff-email"
                    required={false}
                    placeholder="email@domain.com"
                  />
                  <PhoneInput
                    name="staffPhone"
                    label="Phone"
                    id="staff-phone"
                    required={false}
                    placeholder="(555) 555-5555"
                    onChange={(val) => setRecipientToAdd({ ...recipientToAdd, staffPhone: val })}
                  />
                </>
              )}
              {mode === "new" && (
                <>
                  <TextInput
                    id="new-name"
                    name="newName"
                    label="Contact Name"
                    required
                    placeholder="Contact name"
                    onChange={(e) => setRecipientToAdd({ ...recipientToAdd, newName: e.target.value })}
                  />
                  <EmailInput
                    label="Email"
                    name="newEmail"
                    id="new-email"
                    required={!contactForm.getFieldValue("newPhone")}
                    placeholder="email@domain.com"
                    onChange={(e) => setRecipientToAdd({ ...recipientToAdd, newEmail: e.target.value })}
                  />
                  <PhoneInput
                    name="newPhone"
                    label="Phone"
                    id="new-phone"
                    required={!contactForm.getFieldValue("newEmail")}
                    placeholder="(555) 555-5555"
                    onChange={(val) => setRecipientToAdd({ ...recipientToAdd, newPhone: val })}
                  />
                </>
              )}
            </>
          );
        }}
      </Form.Item>
    </Form>
  </StepContainer>
);

export default RecipientStep;
